import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IPlacementTest, IGeneralPlacementTest } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { ADAPTIVE_PLACEMENT_TEST, GENERAL_PLACEMENT_TEST } from 'src/app/dummy/testing';
import { AddMcqGeneralPlacementComponent } from '../add-mcq-general-placement/add-mcq-general-placement.component';
import { AddMcqGeneralPlacementAnswerComponent } from '../add-mcq-general-placement-answer/add-mcq-general-placement-answer.component';

@Component({
  selector: 'app-mcq-general-placement',
  templateUrl: './mcq-general-placement.component.html',
  styleUrls: ['./mcq-general-placement.component.scss']
})
export class McqGeneralPlacementComponent implements OnInit {
  tabs = [{ path: '/testing-center/general-placement-test', label: 'Questions' },];
  TITLE = "General Placement Test"
  equation: string = '';

  SKILL_KEY: any;
  SKILL_OBJECT: any;
  QUESTION_KEY: any;
  CLASS_KEY: any;
  CLASS: any;
  GENERAL_PLACEMENT_TEST = GENERAL_PLACEMENT_TEST;
  ITEM: any;
  QUESTION_LIST: any[];

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: PlacementTest
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }

  goBack() {
    this.router.navigate([`/testing-center/general-placement-test/${this.SKILL_KEY}/${this.CLASS_KEY}`])
  }

  onExercise(control: AbstractControl) {
    if (control && control.value) {
      const { value } = control;
      this.equation = value;
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      question: [null],
      exercise: [null, Validators.compose([Validators.required, this.onExercise.bind(this)])],
    })


    this.route.params.subscribe(async params => {
      const { id, key, skillKey } = params;
      this.QUESTION_KEY = key;
      this.SKILL_KEY = skillKey;
      this.SKILL_OBJECT = GENERAL_PLACEMENT_TEST[this.SKILL_KEY]
      this.CLASS_KEY = id;
      this.tabs = [{ path: `/testing-center/general-placement-test/${this.SKILL_KEY}/${this.CLASS_KEY}/${this.QUESTION_KEY}`, label: this.SKILL_OBJECT.name },];
      this.CLASS = await this.store.fetchClassTesting(id);
      if (!this.CLASS) {
        this.router.navigate([`/404`]);
      }
      if (key !== 'draft') {
        this.store.fetchGeneralPlacementQuestion(this.CLASS_KEY, this.SKILL_KEY, this.QUESTION_KEY, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.QUESTION_LIST = [];
            this.goBack()
            return;
          }
          const { question, exercise, questions } = doc;
          this.form.patchValue({ question, exercise })
          this.QUESTION_LIST = questions;
        })
      }
    })
  }

  onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { question, exercise } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IGeneralPlacementTest = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        question: question || null,
        exercise: exercise || null,
        questions: this.ITEM ? this.ITEM.questions : [],
        skillKey: this.SKILL_KEY,
        classKey: this.CLASS_KEY,
        classRef: this.ds.generalPlacementTestRef().doc(this.CLASS_KEY).ref,
      }
      this.store.addMCQ(activity, (success, res) => {
        if (success) {
          this.snackBar.open("Question has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.location.back()
          }
          else {
            this.router.navigate([`/testing-center/general-placement-test/${this.SKILL_KEY}/${this.CLASS_KEY}/${activity.key}`])
          }
          this.form.enable();
        }
      })
    }
  }


  delete(answer) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: answer.name, title: 'Delete Question' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { exercise, question } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;
        const QUESTION_DATA = removeObjArray(questions, answer.key)
        const registerStatus = STATUS_OBJECT.submitted;
        const activity: IGeneralPlacementTest = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          question: question || null,
          exercise: exercise || null,
          questions: QUESTION_DATA,
          skillKey: this.SKILL_KEY,
          classKey: this.CLASS_KEY,
          classRef: this.ds.generalPlacementTestRef().doc(this.CLASS_KEY).ref,
        }
        this.store.addMCQ(activity, (success, res) => {
          this.snackBar.open("Question has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }



  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddMcqGeneralPlacementComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        QUESTION: item || null,
        SKILL_KEY: this.SKILL_KEY,
        CLASS_KEY: this.CLASS_KEY,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

}
